<script>

</script>

<div class="insider-container">
    
    <div class="top-section">
        <!-- <div class="video-sec">
            <video width="100%" height="100%" autoplay playsinline loop muted class="video-mobile-none insider-pc-video">
                <source src="https://www.qualcomm.com/sites/ember/files/bg-videos/mp4/snapdragon-insiders-graphic-animation-v2_0.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <video height="100%" autoplay loop muted playsinline class="video-pc-none insider-mobile-video">
                <source src="https://www.qualcomm.com/sites/ember/files/bg-videos/mp4/snapdragon-insiders-graphic-animation-550.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div> -->
        <div class="insider-content">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="insider-main-section">
                            <img src="images/qc_x5f_sd_x5f_5g_x5f_badge-cmyk-flat_2_.png" alt="home-logo">
                            <h1>You deserve to be a Snapdragon Insider.</h1>
                            <p>Help us shape the future of Snapdragon, designed to unleash the best smartphone experiences. When you become a Snapdragon Insider, you get exclusive access to events, merch, contests, and master classes that only the Snapdragon Insiders programme can deliver. Join our community to get opportunities to win giveaways and compete in Snapdragon Insiders only gaming tournaments. Sign up today.</p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    
    <div class="insider-bottom-section">
        <div class="">
            <div class="container insider-bottom">
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <p>Sign up for exclusive Snapdragon Insiders emails.</p>
                        <div class="insider-btn">
                            <a href="https://assets.qualcomm.com/Snapdragon-Insiders-Registration-Organic-IN.html?cmpid=snsnin2113" target="_blank" class="sign-up-insider-btn">Sign up</a>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <p>Join the Snapdragon Insiders community.</p>
                        <section class="social-links-top">
                            <div class="container text-center">
                                <ul>
                                    <li>
                                        <a href="https://www.reddit.com/r/snapdragon/" target="_blank">
                                            <img src="images/reddit.png" alt="reddit">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/Snapdragon" target="_blank">
                                            <img src="images/twitter-insider.png" alt="twitter">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/snapdragonofficial/" target="_blank">
                                            <img src="images/insta-insider.png" alt="insta">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/snapdragon/featured" target="_blank">
                                            <img src="images/youtube-insider.png" alt="Youtube">
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>